export const PAGE_PATH = '/public-agreement';
